import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { BankStatementRuleExpressionTypeEnum } from '@zaoblako/shared/modules/document/enums/bank.statement.rule.expression.type.enum';
import { BankStatementRuleExpressionTypeEnumI18n } from '@zaoblako/shared/modules/document/i18n/bank.statement.rule.expression.type.enum.i18n';
import { BankStatementRuleJointTypeEnum } from '@zaoblako/shared/modules/document/enums/bank.statement.rule.joint.type.enum';
import { BankStatementRuleJointTypeEnumI18n } from '@zaoblako/shared/modules/document/i18n/bank.statement.rule.joint.type.enum.i18n';
import { BankStatementRuleConditionFormDto, type BankStatementRuleConditionFormInterface } from '@zaoblako/shared/modules/document/dtos/bank-statement-rule/bank-statement-rule-condition-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';

/** Bank statement rule create and update API's expression request body - DTO signature */
export interface BankStatementRuleExpressionFormInterface {
  /** Expression type */
  type: BankStatementRuleExpressionTypeEnum;
  /** Operator (logical `AND` or logical `OR`) */
  operator?: BankStatementRuleJointTypeEnum;
  /** Condition (pattern to match document) */
  condition?: BankStatementRuleConditionFormInterface;
}

const jointTypeValidator = commonEnumValidator(BankStatementRuleJointTypeEnum, BankStatementRuleJointTypeEnumI18n);

/** Bank statement rule create and update API's expression request body - DTO schema */
export const BankStatementRuleExpressionFormDto = SerdeDtoClass.create<BankStatementRuleExpressionFormInterface>(
  DocumentDtoKeysEnum.BANK_STATEMENT_RULE_EXPRESSION_FORM_DTO,
  {
    type: {
      label: 'Тип выражения',
      serializer: commonEnumValidator(BankStatementRuleExpressionTypeEnum, BankStatementRuleExpressionTypeEnumI18n),
    },
    operator: {
      optional: true,
      label: 'Оператор',
      serializer: () => jointTypeValidator({} as never).when('type', {
        is: BankStatementRuleExpressionTypeEnum.OPERATOR,
        then: (schema) => schema
          .required(DtoMessageEnum.REQUIRED_FIELD)
          .nonNullable(DtoMessageEnum.REQUIRED_FIELD),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
    },
    condition: {
      optional: true,
      label: 'Условие',
      nested: BankStatementRuleConditionFormDto,
      serializer: (_, nested) => nested.when('type', {
        is: BankStatementRuleExpressionTypeEnum.CONDITION,
        then: (schema) => schema
          .required(DtoMessageEnum.REQUIRED_FIELD)
          .nonNullable(DtoMessageEnum.REQUIRED_FIELD),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),
    },
  },
);
